import React from 'react';
import logo from '../img/logo1.jpeg';
import { Link, Outlet} from "react-router-dom";
const Head = () => {
    return (
        <>
            <header className='blur'>
                <div className='container'>
                    <div className='header_box'>
                        <Link to="/">
                            <div className='img_box'>
                                <img src={logo}/>
                            </div>
                        </Link>
                        <div className='header_menu'>
                            <ul className='header_list'>
                                {/* <li><a>Uz</a> / <a>Ru</a></li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </header>
            <Outlet />
        </>
    );
};


export default Head;